import { ParameterType } from '@/study-search/enums';

import { DurationFilterOptionValue } from '@studyportals/search-filters/server-side';
import { FilterDefinition } from '../FilterDefinition';
import { FilterOptionInformation } from '@studyportals/search-filters';

class MastersDurationFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.DURATION,
			[
				new FilterOptionInformation('Less than 1 year', DurationFilterOptionValue.LESS_THAN_ONE_YEAR, '', ''),
				new FilterOptionInformation('1 year', DurationFilterOptionValue.ONE_YEAR, '1-year', '1 Year'),
				new FilterOptionInformation('1½ years', DurationFilterOptionValue.ONE_AND_A_HALF_YEARS, '', ''),
				new FilterOptionInformation('2 years', DurationFilterOptionValue.TWO_YEARS, '2-years', '2 Years'),
				new FilterOptionInformation('More than 2 years', DurationFilterOptionValue.MORE_THAN_TWO_YEARS, '', ''),
			],
			[DurationFilterOptionValue.ONE_YEAR, DurationFilterOptionValue.TWO_YEARS],
		);
	}
}

export default new MastersDurationFilterDefinition();
